<template>
  <div>
    <h6 class="text-left table-header">
      {{ header | i18n }}
    </h6>
    <Table
      :columns="columns"
      :rows="items"
      :pagination="false"
      :on-row-click="rowClick"
      tableName="reportTable"
    />
  </div>
</template>

<script>
import axios from 'axios';

import { CASE_STATUSES } from '../../../../../../../constants';
import Table from '../../common/table';
import { ApiMixin, AuthStorageMixin } from '../../../../mixins';

export default {
  name: 'BaseTable',
  components: { Table },
  mixins: [ApiMixin, AuthStorageMixin],
  props: {
    items: {
      type: Array,
      default: () => []
    },
    header: {
      type: String,
      default: ''
    },
    rowClick: {
      type: Function,
      default: () => {}
    }
  },
  data: function() {
    return {
      statuses: CASE_STATUSES,
      columns: [
        { key: '1', field: 'caseNumber', title: this.$translate('Case Number'), align: 'left' },
        { key: '2', field: 'title', title: this.$translate('title'), align: 'left' },
        {
          key: '3',
          field: 'status',
          title: this.$translate('status'),
          align: 'left',
          renderBodyCell: ({ row }, h) => {
            return <span class={`badge status-badge badge-${row.statusColor}`}> {this.$translate(row.status)} </span>;
          }
        },
        { key: '4', field: 'teamName', title: this.$translate('Team'), align: 'left' },
        { key: '5', field: 'userName', title: this.$translate('In charge'), align: 'left' },
        { key: '6', field: 'updatedAt', title: this.$translate('Updated'), align: 'left' },
        {
          field: 'download',
          title: '',
          key: '7',
          width: 50,
          renderBodyCell: ({ row }, h) => {
            return row.pdf ? (
              <div class="download-buttons">
                <div class="download-button" on-click={e => this.downloadFN(e, row.id, 'zip')}>
                  zip
                </div>
                <div class="download-button" on-click={e => this.downloadFN(e, row.id, 'pdf')}>
                  pdf
                </div>
              </div>
            ) : (
              <div class="download-buttons-no-pdf">{this.$translate('No PDF')}</div>
            );
          }
        }
      ]
    };
  },
  methods: {
    downloadFN(e, id, type) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const auth = this.authStorageService.getAuth();

      window.open(`${axios.defaults.baseURL}/api/v1/reports/report/${id}/${type}?authorization=${auth.access_token_link}`, '_blank');
    },
    getStatusBadgeVariant(status) {
      switch (status) {
        case this.statuses.ACTIVE:
          return 'success';
        case this.statuses.IN_PROGRESS:
          return 'info';
        case this.statuses.FINISHED:
          return 'secondary';
        default:
          return 'secondary';
      }
    }
  }
};
</script>

<style lang="scss">
.case-table {
  tr {
    cursor: pointer;
  }
}

.badge {
  padding: 0.25em 0.4em !important;
}

.table-header {
  color: #5f5f5f !important;
  font-size: 1.3rem !important;
  font-weight: 300;
  margin-bottom: 20px;
  margin-top: 10px;
}

.download-buttons {
  display: flex;
}

.download-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px !important;
  margin: 0px 5px !important;
  color: rgb(49, 141, 255);
  cursor: pointer;
}

.download-buttons-no-pdf {
  display: flex;
  justify-content: center;
}
</style>
